import React from "react";
import "./ApiError.css";
import errorImage from "../../assets/error.png";
// or rename it to error.png for clarity

function ApiError({ message = "Oops! Something went wrong. Please try again later." }) {
    return (
        <div className="error-container">
            <img src={errorImage} alt="Error" className="error-image" />
            <div className="error-message">{message}</div>
        </div>
    );
}

export default ApiError;
